var render = function () {
  var _vm$completeTaskDialo, _vm$completeTaskDialo2, _vm$completeTaskDialo3, _vm$completeTaskDialo4, _vm$completeTaskDialo5;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('v-progress-linear', {
    staticClass: "ma-2",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._l(_vm.displayTasks, function (task) {
    var _task$type;
    return _c('v-card', {
      key: task.xid,
      staticClass: "my-2",
      attrs: {
        "elevation": "2",
        "disabled": _vm.loading
      }
    }, [_c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-list-item', [_c('v-list-item-content', {
      staticClass: "font-weight-medium mx-1",
      staticStyle: {
        "flex": "0 0 content"
      }
    }, [_c('router-link', {
      staticClass: "text-decoration-none",
      attrs: {
        "to": "/dash/jobs/all/".concat(task.jobId)
      }
    }, [_c('span', {
      staticClass: "font-weight-medium mr-2",
      class: task.dependentsCompleted ? 'primary--text' : 'warning--text'
    }, [_vm._v(_vm._s(task.jobNumber))])])], 1), _c('v-list-item-content', {
      staticClass: "mx-1"
    }, [_c('div', [_c('v-chip', {
      staticClass: "mb-0",
      attrs: {
        "label": "",
        "outlined": "",
        "small": ""
      }
    }, [_vm._v(_vm._s((_task$type = task.type) === null || _task$type === void 0 ? void 0 : _task$type.title))]), _c('span', {
      staticClass: "mx-2 caption"
    }, [_vm._v(_vm._s(task.custName))])], 1), task.description ? _c('div', [_c('span', {
      staticClass: "mr-2 text-subtitle-2"
    }, [_vm._v(_vm._s(task.description))])]) : _vm._e()]), _vm.taskAge(task.jobPromised) ? _c('v-list-item-content', {
      staticClass: "text-subtitle-2 mx-2",
      staticStyle: {
        "flex": "0 0 content"
      }
    }, [_c('div', [_c('v-icon', [_vm._v("mdi-calendar")]), _vm._v(_vm._s(_vm.taskAge(task.jobPromised)))], 1)]) : _vm._e(), _c('v-list-item-content', {
      staticClass: "font-weight-medium mx-2",
      staticStyle: {
        "flex": "0 0 content"
      }
    }, [_vm._v(" " + _vm._s(_vm.duration(task.duration)) + " ")]), _c('v-list-item-content', {
      staticClass: "font-weight-medium mx-2",
      staticStyle: {
        "flex": "0 0 content"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": "",
        "large": ""
      },
      on: {
        "click": function click($event) {
          return _vm.clickCompleteTask(task);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("mdi-check")])], 1)], 1)], 1)], 1)], 1);
  }), _c('v-dialog', {
    attrs: {
      "max-width": "90vw",
      "width": "800",
      "loading": "",
      "persistent": ""
    },
    model: {
      value: _vm.completeTaskDialog.show,
      callback: function callback($$v) {
        _vm.$set(_vm.completeTaskDialog, "show", $$v);
      },
      expression: "completeTaskDialog.show"
    }
  }, [_c('v-card', {
    attrs: {
      "loading": _vm.completeTaskDialog.loading,
      "disabled": _vm.completeTaskDialog.loading
    }
  }, [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("Complete Task")]), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('v-row', [_c('v-col', [_c('span', {
    staticClass: "font-weight-medium mr-2",
    class: true ? 'primary--text' : 'warning--text'
  }, [_vm._v(_vm._s((_vm$completeTaskDialo = _vm.completeTaskDialog.task) === null || _vm$completeTaskDialo === void 0 ? void 0 : _vm$completeTaskDialo.jobNumber))]), _c('v-chip', {
    staticClass: "mb-0",
    attrs: {
      "label": "",
      "outlined": "",
      "small": ""
    }
  }, [_vm._v(_vm._s((_vm$completeTaskDialo2 = _vm.completeTaskDialog.task) === null || _vm$completeTaskDialo2 === void 0 ? void 0 : (_vm$completeTaskDialo3 = _vm$completeTaskDialo2.type) === null || _vm$completeTaskDialo3 === void 0 ? void 0 : _vm$completeTaskDialo3.title))]), _c('span', {
    staticClass: "mx-2 caption"
  }, [_vm._v(_vm._s((_vm$completeTaskDialo4 = _vm.completeTaskDialog.task) === null || _vm$completeTaskDialo4 === void 0 ? void 0 : _vm$completeTaskDialo4.custName))]), _c('br'), _c('span', {
    staticClass: "mr-2 text-subtitle-2"
  }, [_vm._v(_vm._s((_vm$completeTaskDialo5 = _vm.completeTaskDialog.task) === null || _vm$completeTaskDialo5 === void 0 ? void 0 : _vm$completeTaskDialo5.description))])], 1)], 1), _c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "placeholder": "Completion notes",
      "hide-details": ""
    },
    model: {
      value: _vm.completeTaskDialog.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.completeTaskDialog, "notes", $$v);
      },
      expression: "completeTaskDialog.notes"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "secondary",
    on: {
      "click": function click($event) {
        _vm.completeTaskDialog.show = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.completeTask
    }
  }, [_vm._v("Complete")])], 1)], 1)], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }